(function Carousl($, Adzuki)
{
	"use strict";
	// Hide Header on on scroll down

	$(document).ready(
		function documentReady() {
			var monthlySailings = $('#monthly-sailing-carousel');

			if (monthlySailings.length) {

				console.log('test');

				$(monthlySailings)
					.carousel(
						{
							interval: false
						}
					)
					.on(
						'slide.bs.carousel', 
						function animateHeight(e) {
							var nextH = $(e.relatedTarget).height();
							$(this)
								.find('.active.item')
								.parent()
								.animate(
									{ 
										height: nextH 
									}
									, 500
								)
							;
						}
					)
				;

			}
		}
	);
	
}(jQuery, window.Adzuki || {}));
